export default "__VITE_PUBLIC_ASSET__4775959b__"